module.exports = __webpack_public_path__ + "static/media/crop-alt-rotate-right.9ef8fbdf.svg";